// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"LocalMarketCommMasterPage_headerActions__1fSQ3","note":"LocalMarketCommMasterPage_note__3en28"};